// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text_lTMWQ {
  font: normal 15px/24px Inter;
  color: #394756;
}
.text_lTMWQ a {
  color: var( --color-linkNormal );
  text-decoration: none;
}
.text_lTMWQ a:hover {
  color: var( --color-linkHover );
}
.text_lTMWQ a:active {
  color: var( --color-linkVisited );
}
.text_lTMWQ a:focus {
  color: var( --color-linkVisited );
}
.text_lTMWQ a:visited {
  color: var( --color-linkVisited );
}
.text_lTMWQ.text-title_WfPPM {
  font: bold 20px Inter;
  color: #181e25;
  text-transform: capitalize;
}
.text_lTMWQ.text-subtitle_t9FZZ {
  font: 600 16px/26px Inter;
  color: #394756;
}
.text_lTMWQ.text-body_imp3J {
  font: normal 16px/26px Inter;
  color: #394756;
}
.text_lTMWQ.text-bodySmall_VKpbM {
  font: normal 15px/24px Inter;
  color: #394756;
}
.text_lTMWQ.text-caption_G4Unj {
  font: 13px/20px Inter;
  color: #394756;
}
.text_lTMWQ.text-captionSmall_Hur6o {
  font: normal 12px/18px Inter;
  color: #394756;
}
.text_lTMWQ.text-subtitle_t9FZZ.text-navLogoLabel_Qd6GS {
  font: bold 16px/24px Inter;
  color: var( --color-white );
}
.text_lTMWQ.text-title_WfPPM.text-pageTitle_mL8wF {
  line-height: 24px;
}
.text_lTMWQ.text-title_WfPPM.text-sectionTitle_esp1b {
  font-size: var( --size-fontBodySmall );
  text-transform: none;
}
.text_lTMWQ.text-title_WfPPM.text-formTitle_9UDmF {
  font: bold 18px/24px Inter;
  color: var( --color-base700 );
}
.text_lTMWQ.text-subtitle_t9FZZ.text-listItemTitle_hIUTK {
  font-weight: 600;
}
.text_lTMWQ.text-captionSmall_Hur6o.text-inputCaptionSmall_MfzSa.text-inputCaptionSmallError_tmzqO {
  color: var( --color-danger500 );
  padding-top: 2px;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-loginWarning_jPgNt {
  color: var( --color-danger500 );
  font-weight: 600;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-mobileMapTitle_bfnfj {
  color: var( --color-white );
  font-weight: bold;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-mobileTitle_uypJS {
  font-weight: 600;
}
.text_lTMWQ.text-captionBold_h1clF {
  font: 600 13px/20px Inter;
  color: #394756;
}
.text_lTMWQ.text-captionSmallBold_L3Rrx {
  font: 600 12px/18px Inter;
  color: #394756;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-detailLabel_lugu0 {
  padding: var( --size-padMedium ) var( --size-padLarge );
  line-height: 27px;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-detailValue_vMTOy {
  font: 600 15px/27px Inter;
  color: var( --color-base700 );
  padding: var( --size-padMedium ) var( --size-padLarge );
}
.text_lTMWQ.text-bodySmall_VKpbM.text-detailValue_vMTOy.text-detailSuffix_H3pak {
  margin-left: -14px;
  margin-right: 0px;
}
.text_lTMWQ.text-title_WfPPM.text-screenTitle_nvkbp {
  font: bold 18px/24px Inter;
  color: var( --color-base900 );
}
.text_lTMWQ.text-sideNav_ginSW {
  font: 600 16px/40px Inter;
  color: var( --color-SideNavText );
  height: 72px;
  padding: var( --size-padLarge );
  overflow: hidden;
  max-width: 200px;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-bottom: 1px solid var( --color-SideNavDivider );
  border-top-color: var( --color-SideNavDivider );
  border-left-color: var( --color-SideNavDivider );
  border-right-color: var( --color-SideNavDivider );
}
.text_lTMWQ.text-loginLogo_G5CgU {
  margin-top: 30px;
}
.text_lTMWQ.text-mobileUserNavBar_UoTrQ {
  font: bold 16px/26px Inter;
  color: var( --color-base700 );
  border-top: 1px solid var( --color-base100 );
  margin-left: var( --size-padMedium );
  margin-right: var( --size-padMedium );
  padding-bottom: var( --size-padMedium );
}
.text_lTMWQ.text-captionSmall_Hur6o.text-groupTitle_uWwWe {
  color: var( --color-base500 );
  font-weight: 600;
  font-variant: small-caps;
  text-transform: uppercase;
}
.text_lTMWQ.text-subtitle_t9FZZ.text-dashboardCardTitle_ejgA8 {
  margin-right: var( --size-medium );
}
.text_lTMWQ.text-title_WfPPM.text-formTitle_9UDmF.text-dialogTitle_aufao.text-rootEditorTitle_GUPMo {
  padding: var( --size-padMedium );
}
.text_lTMWQ.text-actionBar_Rlz6t {
  color: var( --color-base700 );
  font-size: var( --size-fontButtonMedium );
}
.text_lTMWQ.text-captionBold_h1clF.text-sideNavBarHeader_cWVvI {
  color: var( --color-SideNavHeader );
  padding: var( --size-padMedium ) var( --size-large );
}
.text_lTMWQ.text-networkOffline_8Jspf {
  color: var( --color-white );
  padding: var( --size-padMedium ) var( --size-padXLarge ) var( --size-medium );
  background-color: var( --color-danger500 );
}
.text_lTMWQ.text-sideNav_ginSW.text-sideNavSmall_SB676 {
  text-align: center;
  padding-left: 8px;
  padding-right: 8px;
}
.text_lTMWQ.text-linearViewHeaderCell1_GCINt {
  font: 600 13px/var( --size-fontH3 ) Inter;
  color: #394756;
  overflow: hidden;
  white-space: nowrap;
  padding-left: var( --size-padMedium );
  text-overflow: clip;
  padding-right: var( --size-padMedium );
}
.text_lTMWQ.text-linearViewHeaderCell2_U7HiU {
  font: 13px/var( --size-fontCaption ) Inter;
  color: #394756;
  overflow: hidden;
  white-space: nowrap;
  padding-left: var( --size-padMedium );
  text-overflow: clip;
  padding-right: var( --size-padMedium );
}
.text_lTMWQ.text-pairingErrorSubtitle_tQCYt {
  color: var( --color-danger700 );
}
.text_lTMWQ.text-bodyCentered_y32BH {
  text-align: center;
}
.text_lTMWQ.text-resendSuccess_fo8dm {
  border: 1px solid var( --color-success100 );
  padding: var( --size-padSmall );
  border-radius: var( --size-padSmall );
  background-color: var( --color-white );
}
.text_lTMWQ.text-twoFactorWarning_lryJq {
  color: var( --color-danger500 );
  border: 1px solid var( --color-danger100 );
  padding: var( --size-padSmall );
  background-color: var( --color-danger050 );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6 {
  color: var( --color-base800 );
  margin: var( --size-padSmall ) var( --size-padLarge );
  border-radius: 12px;
  background-color: var( --color-base100 );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillPrimary_WlIVu {
  background-color: var( --color-brand050 );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillSuccess_zpDC7 {
  background-color: var( --color-success050 );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillWarning_r7Ifb {
  background-color: var( --color-warning050 );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillError_dE85C {
  color: var( --color-danger900 );
  background-color: var( --color-danger050 );
}
.text_lTMWQ.text-resendCodeSuccess_SbNfE {
  border: 1px solid var( --color-success100 );
  padding: var( --size-padMedium );
  border-radius: 4px;
}
.text_lTMWQ.text-twoStepTitle_wGuTW {
  font: bold 18px/24px Inter;
  color: var( --color-base700 );
}
.text_lTMWQ.text-hint_T10nR {
  color: var( --color-base300 );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR {
  padding: var( --size-padSmall ) var( --size-padMedium );
  font-weight: normal;
  line-height: 22px;
}
.text_lTMWQ.text-columnLabel_kSGax {
  font: 600 14px/20px Inter;
  color: #394756;
  overflow: hidden;
  white-space: nowrap;
  padding-top: var( --size-padSmall );
  padding-left: var( --size-padMedium );
  text-overflow: ellipsis;
  padding-bottom: var( --size-padSmall );
}
.text_lTMWQ.text-missingRelTitle_GidYd {
  color: #ff0000;
}
.text_lTMWQ.text-expressionParen_mVKlJ {
  font-size: var( --size-fontH2 );
}
.text_lTMWQ.text-operatingHoursTitle_GeIqF {
  border-bottom: 1px solid var( --color-base200 );
  padding-bottom: var( --size-padLarge );
}
.text_lTMWQ.text-hint_T10nR.text-hintSmall_wlOan {
  font-size: 14px;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-detailLabel_lugu0.text-aggregationTitle_be0xh {
  padding: 0px 11px;
  overflow: hidden;
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  margin-left: 0px;
  margin-right: 0px;
  text-overflow: ellipsis;
}
.text_lTMWQ.text-aggregationLabel_mBnDK {
  color: currentColor;
  font-size: 12px;
  line-height: 16px;
}
.text_lTMWQ.text-subtitle_t9FZZ.text-aggregationValue_KsauC {
  font: 600 15px/16px Inter;
  color: currentColor;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.text_lTMWQ.text-conditionAttributeLabel_VawrG {
  font-weight: bold;
}
.text_lTMWQ.text-twoFactorWarning_lryJq.text-info_F1rg4 {
  color: var( --color-base600 );
  border: none;
  padding: var( --size-padMedium );
  font-size: var( --size-fontCaption );
  text-transform: none;
  background-color: var( --color-base025 );
}
.text_lTMWQ.text-comparator_HszGC {
  text-align: center;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillError_dE85C.text-tagError_trBFv {
  color: var( --color-danger500 );
  border: 1px solid var( --color-danger500 );
  font-size: var( --size-large );
  font-weight: bold;
  border-radius: 2px;
}
.text_lTMWQ.text-caption_G4Unj.text-captionCurrent_A5P9B {
  color: currentColor;
}
.text_lTMWQ.text-mobileNavSubtitle_A5MAI {
  font: 600 16px/26px Inter;
  color: var( --color-TopNavText );
  height: 48px;
  padding-left: 24px;
  padding-right: 24px;
}
.text_lTMWQ.text-navSecondaryMobileTitle_ZVW2f {
  font: bold 18px/24px Inter;
  color: var( --color-SideNavText );
  height: 48px;
  padding: 8px 16px;
}
.text_lTMWQ.text-navSecondaryMobileHeader_g8eWp {
  font: 600 13px/20px Inter;
  color: var( --color-SideNavHeader );
  width: 100%;
  height: 32px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.text_lTMWQ.text-mobileScreenTitle_CCYjB {
  font: bold 16px/24px Inter;
  color: var( --color-base900 );
  padding: 4px 8px;
}
.text_lTMWQ.text-mobileOptNavTitle_Og862 {
  font: bold 18px/24px Inter;
  color: var( --color-base900 );
}
.text_lTMWQ.text-mobileNavBarHeader_JTqdF {
  font: 600 13px/20px Inter;
  color: var( --color-base600 );
  padding-top: 8px;
  padding-bottom: 8px;
}
.text_lTMWQ.text-ruleTrigger_Vq8NC {
  font: 600 13px/20px Inter;
  color: #394756;
}
.text_lTMWQ.text-ruleBlockTitle_CjUly {
  font: bolder 15px/24px Inter;
  color: var( --color-base700 );
}
.text_lTMWQ.text-ruleBlockDescription_FlK1e {
  font: normal 15px/24px Inter;
  color: var( --color-base700 );
  margin-left: 32px;
  margin-right: var( --size-padXLarge );
  padding-bottom: var( --size-padSmall );
}
.text_lTMWQ.text-caption_G4Unj.text-captionLeft_xOGX5 {
  text-align: left;
}
.text_lTMWQ.text-linkTable_Hyd8b {
  color: var( --color-brand500 );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillStatus_xKjH1 {
  background-color: var( --color-brand050 );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillGood_W23cd {
  background-color: var( --color-success050 );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillAlert_xidrh {
  background-color: var( --color-danger050 );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-value_iVc37 {
  color: var( --color-base800 );
  padding: 2px var( --size-padMedium );
  font-weight: normal;
  border-radius: 12px;
  background-color: transparent;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-value_iVc37.text-valueLowBattery_IcXJv {
  font-weight: 600;
}
.text_lTMWQ.text-subtitle_t9FZZ.text-dashboardCardTitle_ejgA8.text-dashboardGridCardTitle_KM5qN {
  padding-bottom: var( --size-medium );
}
.text_lTMWQ.text-caption_G4Unj.text-passwordRequirement_Ydd82.text-passwordRequirementError_WHJdk {
  color: var( --color-danger700 );
}
.text_lTMWQ.text-releaseAvailable_is_s7 {
  color: var( --color-base700 );
  font-size: var( --size-fontBody );
}
.text_lTMWQ.text-openingHoursHeader_gZsJR {
  font-weight: 500;
}
.text_lTMWQ.text-operatingHoursDay_GKOXX {
  font-weight: 500;
}
.text_lTMWQ.text-groupingsCount_oyrAM {
  font: var( --size-fontCaptionSmall ) var( --fontFamily-body );
  color: var( --color-white );
  padding: var( --size-padSmall ) 8px;
  border-radius: 10000px;
  background-color: var( --color-brand500 );
}
.text_lTMWQ.text-groupingsCount_oyrAM.text-groupingsCountEmpty_Y6pRv {
  color: var( --color-base400 );
  background-color: var( --color-base050 );
}
.text_lTMWQ.text-title_WfPPM.text-formTitle_9UDmF.text-formTitleCenter_AWy0q {
  text-align: center;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-value_iVc37.text-valueGoodBattery_aDKqv {
  font-weight: 600;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-arrayValue_TYuQk {
  font: normal 14px/20px Inter;
  color: var( --color-base800 );
  border: 1px solid transparent;
  margin: 0px;
  padding: 2px var( --size-padMedium );
}
.text_lTMWQ.text-ruleTargetName_n2FXn {
  color: #8a004f;
}
.text_lTMWQ.text-rulePathSeparator_lQihx {
  color: var( --color-base400 );
}
.text_lTMWQ.text-attributeTableUnitSuffix_RKicd {
  color: var( --color-base500 );
  padding-right: 8px;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-selectorColumnValue_e66ec {
  border: 1px solid transparent;
  padding: var( --size-small ) var( --size-medium );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-tablePill_V1b4m {
  margin: var( --size-padSmall ) var( --size-padMedium );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillWarning_r7Ifb.text-tablePillWarning_JIuro {
  margin: var( --size-padSmall ) var( --size-padMedium );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillSuccess_zpDC7.text-tablePillSuccess_AtbUa {
  margin: var( --size-padSmall ) var( --size-padMedium );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillPrimary_WlIVu.text-tablePillPrimary_iAps7 {
  margin: var( --size-padSmall ) var( --size-padMedium );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillError_dE85C.text-tablePillError_j7a2T {
  margin: var( --size-padSmall ) var( --size-padMedium );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillStatus_xKjH1.text-tablePillStatus_qdYQo {
  margin: var( --size-padSmall ) var( --size-padMedium );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillGood_W23cd.text-tablePillGood_LexDk {
  margin: var( --size-padSmall ) var( --size-padMedium );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillAlert_xidrh.text-tablePillAlert_lMRSB {
  margin: var( --size-padSmall ) var( --size-padMedium );
}
.text_lTMWQ.text-deviceSelectorResults_B1FMI {
  margin-top: var( --size-padLarge );
}
.text_lTMWQ.text-tempUserShareError_fnb0z {
  color: var( --color-danger700 );
  width: auto;
  border: 1px solid var( --color-danger700 );
  padding: 8px;
  font-size: var( --size-fontBodySmall );
  font-weight: 600;
  border-radius: var( --size-padSmall );
  background-color: var( --color-danger050 );
}
.text_lTMWQ.text-aggregationLabel_mBnDK.text-aggregationEnumAggLabel_KjzQ3 {
  text-transform: capitalize;
}
.text_lTMWQ.text-caption_G4Unj.text-inputCaption_Xhej2 {
  color: var( --color-base500 );
  padding-top: 6px;
}
.text_lTMWQ.text-attributeDetailUnitSuffix_hu4IC {
  color: var( --color-base700 );
  font-weight: 600;
}
.text_lTMWQ.text-attributePercentEditor_Q3FWq {
  min-width: 35px;
  text-align: center;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-detailValue_vMTOy.text-detailValueNoPad_BuTAs {
  padding: 0px;
}
.text_lTMWQ.text-title_WfPPM.text-tvCollectionItemTitle_aGmSG {
  color: var( --color-base800 );
  text-align: left;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-detailLabel_lugu0.text-tvDetailLabelNoPad_gGNvp {
  color: var( --color-base800 );
  padding: 0px;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-detailValue_vMTOy.text-detailValueNoPad_BuTAs.text-tvDetailValueNoPad_QYW5n {
  color: var( --color-base800 );
}
.text_lTMWQ.text-title_WfPPM.text-deviceCode_e54cN {
  font: 600 var( --size-padXXLarge ) Inter;
}
.text_lTMWQ.text-iconSuccessLarge_hzpKM {
  color: var( --color-success700 );
  font-size: 90px;
}
.text_lTMWQ.text-title_WfPPM.text-titleLarge_gKZ1G {
  font-size: 50px;
}
.text_lTMWQ.text-body_imp3J.text-bodyLarge_aB4ed {
  font-size: 20px;
}
.text_lTMWQ.text-captionSmall_Hur6o.text-altLoginMethod_W7XQX {
  height: 40px;
  max-width: 90px;
}
.text_lTMWQ.text-captionSmall_Hur6o.text-altLoginMethod_W7XQX.text-altLoginMethodSmall_RfXYY {
  height: auto;
  font-size: var( --size-fontBodySmall );
}
.text_lTMWQ.text-bodySmall_VKpbM.text-bodySmallBold_XlW6h {
  font-weight: bold;
}
.text_lTMWQ.text-body_imp3J.text-formBody_vQoVb.text-formBodyCenter___dyo.text-qrCodeInstruction__GZxg {
  text-align: center;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-bodySmallBold_XlW6h.text-bodySmallBoldCenter_KLVgU {
  text-align: center;
}
.text_lTMWQ.text-title_WfPPM.text-userCode_z2SBv {
  text-transform: none;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-bodySmallCenter_E5Czf {
  text-align: center;
}
.text_lTMWQ.text-body_imp3J.text-formBody_vQoVb.text-formBodyCenter___dyo {
  text-align: center;
  text-decoration: none;
}
.text_lTMWQ.text-errorTitle_nPw25 {
  color: var( --color-danger500 );
  font-size: var( --size-large );
  font-weight: 600;
  line-height: var( --size-padXLarge );
}
.text_lTMWQ.text-title_WfPPM.text-pageTitle_mL8wF.text-rsrcImageDetailTitle_FD36I {
  color: var( --color-white );
  overflow: hidden;
  max-width: 50dvw;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.text_lTMWQ.text-detailRsrcTitle_NcBVc {
  overflow: hidden;
  max-width: 90%;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.text_lTMWQ.text-perPage_t4EWD {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
}
.text_lTMWQ.text-layerToolbar_shTQ0 {
  color: var( --color-white );
  width: 30px;
  height: 30px;
  font-size: var( --size-fontH2 );
  font-weight: bold;
}
.text_lTMWQ.text-videoControlsLoader_KOwTo {
  color: var( --color-white );
  font-size: 48px;
  font-weight: bold;
}
.text_lTMWQ.text-errorTitle_nPw25.text-videoControlsError_BzGT4 {
  text-align: center;
}
.text_lTMWQ.text-videoControlsPoster_yQ1XP {
  color: var( --color-white );
  font-size: var( --size-fontH1 );
}
.text_lTMWQ.text-captionSmall_Hur6o.text-timelineAxisTick_eWRhv.text-timelineAxisSubTick_djGrt {
  color: var( --color-base300 );
}
.text_lTMWQ.text-videoControlsMessage_JwquU {
  color: var( --color-white );
  font-size: var( --size-fontH2 );
  text-align: center;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillStatus_xKjH1.text-videoPlayerPill_XISjX {
  color: var( --color-tertiaryBrandD );
  background-color: #dae1fa;
}
.text_lTMWQ.text-subtitle_t9FZZ.text-detailTitle_TihjK.text-detailRsrcItemTitle_uui09 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-detailValue_vMTOy.text-detailRsrcItemValue_zffQv {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.text_lTMWQ.text-errorTitle_nPw25.text-videoControlsError_BzGT4.text-rsrcTimelineMessage_ujc5T {
  color: var( --color-base700 );
}
.text_lTMWQ.text-loadingSpinnerLarge_Gmyyg.text-loadingSpinnerLargeLight_QZgPe {
  color: var( --color-white );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillSuccess_zpDC7.text-pillClosed_vMGFz {
  background-color: var( --color-base050 );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillWarning_r7Ifb.text-pillOpen_jD8Rm.text-tablePillOpen_OLmro {
  color: var( --color-base700 );
  margin: var( --size-padSmall ) var( --size-padMedium );
  font-size: var( --size-fontBodySmall );
  font-weight: 500;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillSuccess_zpDC7.text-pillClosed_vMGFz.text-tablePillClosed_FyVdU {
  color: var( --color-base700 );
  margin: var( --size-padSmall ) var( --size-padMedium );
  font-size: var( --size-fontBodySmall );
  font-weight: 500;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillSuccess_zpDC7.text-pillSourceUser_GTwwJ {
  background-color: #e0f7f7;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillSuccess_zpDC7.text-pillSourceUser_GTwwJ.text-tablePillSourceUser_l8eJ1 {
  color: var( --color-base700 );
  margin: var( --size-padSmall ) var( --size-padMedium );
  font-size: var( --size-fontBodySmall );
  font-weight: 500;
  background-color: #d8e3fc;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillSuccess_zpDC7.text-pillSourceUser_GTwwJ.text-pillSourceAi_YLYHH.text-tablePillSourceAi_cGaMD {
  color: var( --color-base700 );
  margin: var( --size-padSmall ) var( --size-padMedium );
  font-size: var( --size-fontBodySmall );
  font-weight: 500;
  background-color: var( --color-success050 );
}
.text_lTMWQ.text-bodySmall_VKpbM.text-detailValue_vMTOy.text-ogDetailValue_QHWNI {
  margin-left: auto;
}
.text_lTMWQ.text-chartRolloverHeader_GPVIK {
  padding: 8px 12px;
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid var( --color-base200 );
  background-color: var( --color-base050 );
}
.text_lTMWQ.text-lineDetailLabel_v7olj {
  font-size: var( --size-fontH3 );
}
.text_lTMWQ.text-linePerformancePill_pitWB {
  padding: 2px 8px;
  font-weight: 600;
  border-radius: 12px;
  background-color: var( --color-base100 );
}
.text_lTMWQ.text-moldHalfDetailValue_WhGce {
  font-size: var( --size-fontBody );
  font-weight: bold;
}
.text_lTMWQ.text-moldHalfStageDetailValue_CVzmM {
  font-size: var( --size-fontH2 );
  font-weight: 600;
}
.text_lTMWQ.text-captionBold_h1clF.text-workerCountTitle_PIip6 {
  font-size: 14px;
  text-transform: uppercase;
}
.text_lTMWQ.text-bodySmall_VKpbM.text-detailValue_vMTOy.text-ganttRolloverValue_AG0xR {
  margin-left: auto;
}
.text_lTMWQ.text-subtitle_t9FZZ.text-editorTitle_Qp6Lf.text-ganttRolloverHeader_AqQ3u {
  padding: 8px 12px;
  border-bottom: 1px solid var( --color-base200 );
  background-color: var( --color-base050 );
}
.text_lTMWQ.text-paceGood_GM9Qj {
  color: #029e2e;
  font-size: 50px;
  font-weight: 700;
  line-height: 32px;
}
.text_lTMWQ.text-paceGood_GM9Qj.text-paceBad_X6xs9 {
  color: var( --color-danger500 );
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnLabelCustom_tpNtJ {
  padding: 0px 6px;
  font-size: 15px;
  line-height: 36px;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnLabelCustom_tpNtJ.text-columnLabelCustomVertical_L6wZQ {
  width: fit-content;
  font-size: 16px;
  line-height: 16px;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnLabelCustom_tpNtJ.text-columnLabelCustomVertical_L6wZQ.text-columnSubCustomVertical_B8HFC {
  font-size: 12px;
  font-weight: normal;
  line-height: 12px;
}
.text_lTMWQ.text-columnHeaderCustom_pQdhw {
  font-size: 16px;
  font-weight: 600;
}
.text_lTMWQ.text-paceCardHeader_NXwa9 {
  height: 26px;
  font-size: 20px;
  font-weight: 800;
  line-height: 26px;
}
.text_lTMWQ.text-paceCardDetailContent_hUfT7 {
  font-size: 32px;
  font-weight: 600;
  line-height: 20px;
}
.text_lTMWQ.text-caption_G4Unj.text-paceCardDetailHeader_trzS2 {
  overflow: hidden;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: clip;
}
.text_lTMWQ.text-paceGood_GM9Qj.text-pace__NiLC {
  color: var( --color-base700 );
  padding: 0px;
  font-weight: 700;
}
.text_lTMWQ.text-paceCardHeader_NXwa9.text-overallPaceCardHeader_FAW7V {
  height: auto;
  font-size: 20px;
  text-align: center;
  line-height: 39px;
}
.text_lTMWQ.text-paceCardHeader_NXwa9.text-factoryPaceCardHeader_jKteF {
  font-size: 14px;
}
.text_lTMWQ.text-paceGood_GM9Qj.text-factoryPaceGood_KQSZQ {
  padding: 0px 0px 0px 4px;
  font-size: 16px;
  line-height: 18px;
}
.text_lTMWQ.text-paceGood_GM9Qj.text-paceBad_X6xs9.text-factoryPaceBad_cPQTj {
  padding: 0px 0px 0px 4px;
  font-size: 16px;
  line-height: 18px;
}
.text_lTMWQ.text-caption_G4Unj.text-paceCardDetailHeader_trzS2.text-factoryPaceCardDetailHeader_N9Ykj {
  font-size: 14px;
}
.text_lTMWQ.text-factoryOverallPace_sxdWZ {
  color: var( --color-base700 );
  font-size: 38px;
  font-weight: 700;
  line-height: 46px;
}
.text_lTMWQ.text-caption_G4Unj.text-paceCardDetailHeader_trzS2.text-overallPaceCardDetailHeader_XkAcH {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
}
.text_lTMWQ.text-caption_G4Unj.text-paceCardDetailHeader_trzS2.text-overallPaceCardDetailHeader_XkAcH.text-overallPaceCardDetailHeaderSmall_Kabh_ {
  font-size: 14px;
  line-height: 16px;
}
.text_lTMWQ.text-paceCardDetailContent_hUfT7.text-overallPaceCardDetailContent_vO4FN {
  font-size: 26px;
}
.text_lTMWQ.text-paceCardDetailContent_hUfT7.text-factoryPaceCardDetailContent_kGVAY {
  font-size: 16px;
  line-height: 16px;
}
.text_lTMWQ.text-factoryNoCollectionHeader_Wb4jQ {
  color: var( --color-danger500 );
  font-size: 24px;
  font-weight: 700;
}
.text_lTMWQ.text-factoryNoCollectionBody_PXZc_ {
  width: 510px;
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
}
.text_lTMWQ.text-mobilePaceCardHeader_g4PVM {
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}
.text_lTMWQ.text-paceGood_GM9Qj.text-factoryPaceGood_KQSZQ.text-mobilePaceGood_XBa0g {
  font-size: 30px;
  font-weight: 700;
  padding-left: 4px;
}
.text_lTMWQ.text-paceGood_GM9Qj.text-paceBad_X6xs9.text-factoryPaceBad_cPQTj.text-mobilePaceBad_f566Z {
  font-size: 30px;
  font-weight: 700;
}
.text_lTMWQ.text-paceGood_GM9Qj.text-factoryPaceGood_KQSZQ.text-mobilePaceGood_XBa0g.text-mobileSmallPaceGood_dL3Am {
  font-size: 20px;
}
.text_lTMWQ.text-paceGood_GM9Qj.text-paceBad_X6xs9.text-factoryPaceBad_cPQTj.text-mobilePaceBad_f566Z.text-mobileSmallPaceBad_ks6Jd {
  font-size: 20px;
}
.text_lTMWQ.text-factoryNoCollectionHeader_Wb4jQ.text-mobileNoCollectionHeader_SkD2e {
  font-size: 12px;
  line-height: 15px;
}
.text_lTMWQ.text-factoryNoCollectionBody_PXZc_.text-mobileNoCollectionBody_ZoiQN {
  width: auto;
  font-size: 10px;
  line-height: 16px;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-pill_qbxb6.text-pillInProgress_SHz08.text-tablePillInProgress_JpI05 {
  margin: var( --size-padSmall ) var( --size-padMedium );
}
.text_lTMWQ.text-plyLayerTitle_h2rD1 {
  color: var( --color-white );
  font-size: 70cqh;
  font-weight: bold;
}
.text_lTMWQ.text-plyLayerLastUpdated_oKH5x {
  color: var( --color-white );
  font-size: 45cqh;
}
.text_lTMWQ.text-plyLayerCurrentTitle_qp3Mi {
  font-size: 16cqh;
  font-weight: 600;
}
.text_lTMWQ.text-plyLayerCurrentId_HgPGb {
  font-size: 42cqw;
  font-weight: 600;
}
.text_lTMWQ.text-plyLayerPill_sOKkq {
  color: var( --color-white );
  border: 3px solid var( --color-bespokeWarningBorder );
  font-size: 40cqh;
  font-weight: 700;
  border-radius: 6cqh;
  background-color: var( --color-bespokeWarningBorder );
}
.text_lTMWQ.text-plyLayerPill_sOKkq.text-plyLayerPillSuccess_Ir1de {
  color: var( --color-white );
  font-size: 1em;
  font-weight: 600;
  background-color: var( --color-bespokeSuccessBorder );
  border-top-color: var( --color-bespokeSuccessBorder );
  border-left-color: var( --color-bespokeSuccessBorder );
  border-right-color: var( --color-bespokeSuccessBorder );
  border-bottom-color: var( --color-bespokeSuccessBorder );
}
.text_lTMWQ.text-plyLayerPill_sOKkq.text-plyLayerPillSuccess_Ir1de.text-plyLayerPillSuccessLarge_Ie38t {
  font-size: 14cqh;
  border-radius: 32px;
  border-top-width: 2cqh;
  border-left-width: 2cqh;
  border-right-width: 2cqh;
  border-bottom-width: 2cqh;
}
.text_lTMWQ.text-plyLayerPill_sOKkq.text-plyLayerPillError_jSE89 {
  background-color: var( --color-pillErrorBorder );
  border-top-color: var( --color-bespokeErrorBorder );
  border-left-color: var( --color-bespokeErrorBorder );
  border-right-color: var( --color-bespokeErrorBorder );
  border-bottom-color: var( --color-bespokeErrorBorder );
}
.text_lTMWQ.text-plyLayerPill_sOKkq.text-plyLayerPillError_jSE89.text-plyLayerPillErrorLarge_zBejt {
  font-size: 14cqh;
  border-radius: 32px;
  border-top-width: 2cqh;
  border-left-width: 2cqh;
  border-right-width: 2cqh;
  border-bottom-width: 2cqh;
}
.text_lTMWQ.text-plyLayerPreviousHeader_u8lSx {
  font-size: 7cqh;
  font-weight: 600;
}
.text_lTMWQ.text-plyLayerPill_sOKkq.text-plyLayerPillLarge_xozOi {
  font-size: 14cqh;
  border-radius: 32px;
  border-top-width: 2cqh;
  border-left-width: 2cqh;
  border-right-width: 2cqh;
  border-bottom-width: 2cqh;
}
.text_lTMWQ.text-plyLayerPill_sOKkq.text-plyLayerPillInProgress_NCRSI {
  background-color: var( --color-base300 );
  border-top-color: var( --color-base300 );
  border-left-color: var( --color-base300 );
  border-right-color: var( --color-base300 );
  border-bottom-color: var( --color-base300 );
}
.text_lTMWQ.text-plyLayerPill_sOKkq.text-plyLayerPillInProgress_NCRSI.text-plyLayerPillInProgressLarge_ApEQa {
  font-size: 14cqh;
  border-radius: 32px;
  border-top-width: 2cqh;
  border-left-width: 2cqh;
  border-right-width: 2cqh;
  border-bottom-width: 2cqh;
}
.text_lTMWQ.text-plyLayerCurrentId_HgPGb.text-plyLayerPreviousId_S2qx8 {
  overflow: hidden;
  font-size: 8cqw;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.text_lTMWQ.text-plyLayerNoDataTitle_r6fTt {
  color: var( --color-white );
  font-size: 8vh;
}
.text_lTMWQ.text-plyLayerNoDataSubtitle_xKjAg {
  color: var( --color-white );
  font-size: 4vh;
}
.text_lTMWQ.text-delayDescriptionTitle_nEyMA {
  font-size: 20px;
  font-weight: 700;
}
.text_lTMWQ.text-delayDescriptionSub_IeUb3 {
  font-size: 14px;
  font-weight: 400;
}
.text_lTMWQ.text-mobileSmallPaceIdle_mw_5x {
  font-size: 20px;
  font-weight: 700;
}
.text_lTMWQ.text-plyLayerTitle_h2rD1.text-plyLayersSubtitle_qHXn0 {
  font-size: 3.5cqh;
}
.text_lTMWQ.text-plyLayerTitle_h2rD1.text-plyLayersSubtitle_qHXn0.text-plyLayerStatsSubtitle_CE_8g {
  font-size: 60cqh;
}
.text_lTMWQ.text-pdfHeaderTitle_aHC8W {
  font-size: 18px;
  font-weight: 600;
  line-height: 18px;
}
.text_lTMWQ.text-pdfHeaderSub_thFEh {
  font-size: 14px;
  font-weight: 400;
}
.text_lTMWQ.text-pdfTableHeader__2_4R {
  padding: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
.text_lTMWQ.text-columnLabel_kSGax.text-columnValue_KQIIR.text-columnValueFixedWidth_ixWRT {
  max-width: 400px;
}
.text_lTMWQ.text-plyLayerPill_sOKkq.text-plyLayerPillUnverifiedTimeout_n99ik {
  background-color: #194edc;
  border-top-style: solid;
  border-top-color: #194edc;
  border-left-style: solid;
  border-left-color: #194edc;
  border-right-style: solid;
  border-right-color: #194edc;
  border-bottom-style: solid;
  border-bottom-color: #194edc;
}
.text_lTMWQ.text-plyLayerShopFloorPill_cyNsn {
  color: var( --color-white );
  border: 3px solid var( --color-bespokeWarningBorder );
  font-weight: bold;
  border-radius: 6px;
  background-color: var( --color-bespokeWarningBorder );
}
.text_lTMWQ.text-plyLayerShopFloorPill_cyNsn.text-plyLayerShopFloorPillSuccess_Gj2JD {
  background-color: var( --color-bespokeSuccessBorder );
  border-top-color: var( --color-bespokeSuccessBorder );
  border-left-color: var( --color-bespokeSuccessBorder );
  border-right-color: var( --color-bespokeSuccessBorder );
  border-bottom-color: var( --color-bespokeSuccessBorder );
}
.text_lTMWQ.text-plyLayerShopFloorPill_cyNsn.text-plyLayerShopFloorPillError_tZU2m {
  background-color: var( --color-pillErrorBorder );
  border-top-color: var( --color-pillErrorBorder );
  border-left-color: var( --color-pillErrorBorder );
  border-right-color: var( --color-pillErrorBorder );
  border-bottom-color: var( --color-pillErrorBorder );
}
.text_lTMWQ.text-plyLayerShopFloorPill_cyNsn.text-plyLayerShopFloorPillUnverifiedTimeout_baep9 {
  background-color: #194edc;
  border-top-color: #194edc;
  border-left-color: #194edc;
  border-right-color: #194edc;
  border-bottom-color: #194edc;
}
.text_lTMWQ.text-plyLayerShopFloorPill_cyNsn.text-plyLayerShopFloorPillInProgress_V1ZRa {
  background-color: var( --color-base300 );
  border-top-color: var( --color-base300 );
  border-left-color: var( --color-base300 );
  border-right-color: var( --color-base300 );
  border-bottom-color: var( --color-base300 );
}
.text_lTMWQ.text-subtitle_t9FZZ.text-loadTimeoutError_rf9SV {
  color: var( --color-white );
  text-align: center;
}
.text-tagGood_pmw3K {
  color: #097b22;
  border: 1px solid #097b22;
  height: 26px;
  padding: 0px 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  border-radius: 4px;
  background-color: #e6fcef;
}
.text-tagGood_pmw3K.text-tagBad_nFRdF {
  color: #db253d;
  background-color: #fde2e2;
  border-top-color: #db253d;
  border-left-color: #db253d;
  border-right-color: #db253d;
  border-bottom-color: #db253d;
}
.text-tagGood_pmw3K.text-tagNeutral_lwBgw {
  color: #394756;
  background-color: #f3f5f6;
  border-top-color: #acb7c3;
  border-left-color: #acb7c3;
  border-right-color: #acb7c3;
  border-bottom-color: #acb7c3;
}
.text-tagGood_pmw3K.text-mobileTagGood_KZoTc {
  font-size: 14px;
}
.text-tagGood_pmw3K.text-tagBad_nFRdF.text-mobileTagBad_aaMH1 {
  font-size: 14px;
}
.text-tagGood_pmw3K.text-tagNeutral_lwBgw.text-mobileTagNeutral_nMJc_ {
  font-size: 14px;
}
.text-mobilePaceCardBigHeader_CFJHk {
  font-size: 20px;
  font-weight: 700;
}
.text-paceIdle_cXm5B {
  font-size: 50px;
  font-weight: 700;
  line-height: 1em;
}
.text-factoryPaceIdle_dztb3 {
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
}`, "",{"version":3,"sources":["webpack://./src/theme/Text.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sCAAsC;EACtC,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,uDAAuD;EACvD,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,uDAAuD;AACzD;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sDAAsD;EACtD,+CAA+C;EAC/C,gDAAgD;EAChD,iDAAiD;AACnD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,4CAA4C;EAC5C,oCAAoC;EACpC,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,mCAAmC;EACnC,oDAAoD;AACtD;AACA;EACE,2BAA2B;EAC3B,6EAA6E;EAC7E,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,+BAA+B;EAC/B,0CAA0C;AAC5C;AACA;EACE,6BAA6B;EAC7B,qDAAqD;EACrD,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;AACA;EACE,2CAA2C;EAC3C,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,uDAAuD;EACvD,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,qCAAqC;EACrC,uBAAuB;EACvB,sCAAsC;AACxC;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+CAA+C;EAC/C,sCAAsC;AACxC;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gCAAgC;EAChC,oCAAoC;EACpC,oBAAoB;EACpB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,mCAAmC;EACnC,sBAAsB;EACtB,yCAAyC;AAC3C;AACA;EACE,6BAA6B;EAC7B,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,iDAAiD;AACnD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,WAAW;EACX,0CAA0C;EAC1C,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;AAC5C;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,6BAA6B;EAC7B,sDAAsD;EACtD,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,sDAAsD;EACtD,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,sDAAsD;EACtD,sCAAsC;EACtC,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,sDAAsD;EACtD,sCAAsC;EACtC,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,wCAAwC;AAC1C;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,wCAAwC;AAC1C;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,sDAAsD;AACxD;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qDAAqD;AACvD;AACA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,qDAAqD;EACrD,qDAAqD;EACrD,sDAAsD;EACtD,uDAAuD;EACvD,wDAAwD;AAC1D;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,gDAAgD;EAChD,mDAAmD;EACnD,oDAAoD;EACpD,qDAAqD;EACrD,sDAAsD;AACxD;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,iBAAiB;EACjB,kBAAkB;EAClB,qDAAqD;AACvD;AACA;EACE,qDAAqD;EACrD,qDAAqD;EACrD,sDAAsD;EACtD,uDAAuD;EACvD,wDAAwD;AAC1D;AACA;EACE,gDAAgD;EAChD,gDAAgD;EAChD,iDAAiD;EACjD,kDAAkD;EAClD,mDAAmD;AACrD;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".text {\n  font: normal 15px/24px Inter;\n  color: #394756;\n}\n.text a {\n  color: var( --color-linkNormal );\n  text-decoration: none;\n}\n.text a:hover {\n  color: var( --color-linkHover );\n}\n.text a:active {\n  color: var( --color-linkVisited );\n}\n.text a:focus {\n  color: var( --color-linkVisited );\n}\n.text a:visited {\n  color: var( --color-linkVisited );\n}\n.text.text-title {\n  font: bold 20px Inter;\n  color: #181e25;\n  text-transform: capitalize;\n}\n.text.text-subtitle {\n  font: 600 16px/26px Inter;\n  color: #394756;\n}\n.text.text-body {\n  font: normal 16px/26px Inter;\n  color: #394756;\n}\n.text.text-bodySmall {\n  font: normal 15px/24px Inter;\n  color: #394756;\n}\n.text.text-caption {\n  font: 13px/20px Inter;\n  color: #394756;\n}\n.text.text-captionSmall {\n  font: normal 12px/18px Inter;\n  color: #394756;\n}\n.text.text-subtitle.text-navLogoLabel {\n  font: bold 16px/24px Inter;\n  color: var( --color-white );\n}\n.text.text-title.text-pageTitle {\n  line-height: 24px;\n}\n.text.text-title.text-sectionTitle {\n  font-size: var( --size-fontBodySmall );\n  text-transform: none;\n}\n.text.text-title.text-formTitle {\n  font: bold 18px/24px Inter;\n  color: var( --color-base700 );\n}\n.text.text-subtitle.text-listItemTitle {\n  font-weight: 600;\n}\n.text.text-captionSmall.text-inputCaptionSmall.text-inputCaptionSmallError {\n  color: var( --color-danger500 );\n  padding-top: 2px;\n}\n.text.text-bodySmall.text-loginWarning {\n  color: var( --color-danger500 );\n  font-weight: 600;\n}\n.text.text-bodySmall.text-mobileMapTitle {\n  color: var( --color-white );\n  font-weight: bold;\n}\n.text.text-bodySmall.text-mobileTitle {\n  font-weight: 600;\n}\n.text.text-captionBold {\n  font: 600 13px/20px Inter;\n  color: #394756;\n}\n.text.text-captionSmallBold {\n  font: 600 12px/18px Inter;\n  color: #394756;\n}\n.text.text-bodySmall.text-detailLabel {\n  padding: var( --size-padMedium ) var( --size-padLarge );\n  line-height: 27px;\n}\n.text.text-bodySmall.text-detailValue {\n  font: 600 15px/27px Inter;\n  color: var( --color-base700 );\n  padding: var( --size-padMedium ) var( --size-padLarge );\n}\n.text.text-bodySmall.text-detailValue.text-detailSuffix {\n  margin-left: -14px;\n  margin-right: 0px;\n}\n.text.text-title.text-screenTitle {\n  font: bold 18px/24px Inter;\n  color: var( --color-base900 );\n}\n.text.text-sideNav {\n  font: 600 16px/40px Inter;\n  color: var( --color-SideNavText );\n  height: 72px;\n  padding: var( --size-padLarge );\n  overflow: hidden;\n  max-width: 200px;\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  border-bottom: 1px solid var( --color-SideNavDivider );\n  border-top-color: var( --color-SideNavDivider );\n  border-left-color: var( --color-SideNavDivider );\n  border-right-color: var( --color-SideNavDivider );\n}\n.text.text-loginLogo {\n  margin-top: 30px;\n}\n.text.text-mobileUserNavBar {\n  font: bold 16px/26px Inter;\n  color: var( --color-base700 );\n  border-top: 1px solid var( --color-base100 );\n  margin-left: var( --size-padMedium );\n  margin-right: var( --size-padMedium );\n  padding-bottom: var( --size-padMedium );\n}\n.text.text-captionSmall.text-groupTitle {\n  color: var( --color-base500 );\n  font-weight: 600;\n  font-variant: small-caps;\n  text-transform: uppercase;\n}\n.text.text-subtitle.text-dashboardCardTitle {\n  margin-right: var( --size-medium );\n}\n.text.text-title.text-formTitle.text-dialogTitle.text-rootEditorTitle {\n  padding: var( --size-padMedium );\n}\n.text.text-actionBar {\n  color: var( --color-base700 );\n  font-size: var( --size-fontButtonMedium );\n}\n.text.text-captionBold.text-sideNavBarHeader {\n  color: var( --color-SideNavHeader );\n  padding: var( --size-padMedium ) var( --size-large );\n}\n.text.text-networkOffline {\n  color: var( --color-white );\n  padding: var( --size-padMedium ) var( --size-padXLarge ) var( --size-medium );\n  background-color: var( --color-danger500 );\n}\n.text.text-sideNav.text-sideNavSmall {\n  text-align: center;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.text.text-linearViewHeaderCell1 {\n  font: 600 13px/var( --size-fontH3 ) Inter;\n  color: #394756;\n  overflow: hidden;\n  white-space: nowrap;\n  padding-left: var( --size-padMedium );\n  text-overflow: clip;\n  padding-right: var( --size-padMedium );\n}\n.text.text-linearViewHeaderCell2 {\n  font: 13px/var( --size-fontCaption ) Inter;\n  color: #394756;\n  overflow: hidden;\n  white-space: nowrap;\n  padding-left: var( --size-padMedium );\n  text-overflow: clip;\n  padding-right: var( --size-padMedium );\n}\n.text.text-pairingErrorSubtitle {\n  color: var( --color-danger700 );\n}\n.text.text-bodyCentered {\n  text-align: center;\n}\n.text.text-resendSuccess {\n  border: 1px solid var( --color-success100 );\n  padding: var( --size-padSmall );\n  border-radius: var( --size-padSmall );\n  background-color: var( --color-white );\n}\n.text.text-twoFactorWarning {\n  color: var( --color-danger500 );\n  border: 1px solid var( --color-danger100 );\n  padding: var( --size-padSmall );\n  background-color: var( --color-danger050 );\n}\n.text.text-columnLabel.text-columnValue.text-pill {\n  color: var( --color-base800 );\n  margin: var( --size-padSmall ) var( --size-padLarge );\n  border-radius: 12px;\n  background-color: var( --color-base100 );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillPrimary {\n  background-color: var( --color-brand050 );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillSuccess {\n  background-color: var( --color-success050 );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillWarning {\n  background-color: var( --color-warning050 );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillError {\n  color: var( --color-danger900 );\n  background-color: var( --color-danger050 );\n}\n.text.text-resendCodeSuccess {\n  border: 1px solid var( --color-success100 );\n  padding: var( --size-padMedium );\n  border-radius: 4px;\n}\n.text.text-twoStepTitle {\n  font: bold 18px/24px Inter;\n  color: var( --color-base700 );\n}\n.text.text-hint {\n  color: var( --color-base300 );\n}\n.text.text-columnLabel.text-columnValue {\n  padding: var( --size-padSmall ) var( --size-padMedium );\n  font-weight: normal;\n  line-height: 22px;\n}\n.text.text-columnLabel {\n  font: 600 14px/20px Inter;\n  color: #394756;\n  overflow: hidden;\n  white-space: nowrap;\n  padding-top: var( --size-padSmall );\n  padding-left: var( --size-padMedium );\n  text-overflow: ellipsis;\n  padding-bottom: var( --size-padSmall );\n}\n.text.text-missingRelTitle {\n  color: #ff0000;\n}\n.text.text-expressionParen {\n  font-size: var( --size-fontH2 );\n}\n.text.text-operatingHoursTitle {\n  border-bottom: 1px solid var( --color-base200 );\n  padding-bottom: var( --size-padLarge );\n}\n.text.text-hint.text-hintSmall {\n  font-size: 14px;\n}\n.text.text-bodySmall.text-detailLabel.text-aggregationTitle {\n  padding: 0px 11px;\n  overflow: hidden;\n  font-size: 14px;\n  font-weight: bold;\n  white-space: nowrap;\n  margin-left: 0px;\n  margin-right: 0px;\n  text-overflow: ellipsis;\n}\n.text.text-aggregationLabel {\n  color: currentColor;\n  font-size: 12px;\n  line-height: 16px;\n}\n.text.text-subtitle.text-aggregationValue {\n  font: 600 15px/16px Inter;\n  color: currentColor;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.text.text-conditionAttributeLabel {\n  font-weight: bold;\n}\n.text.text-twoFactorWarning.text-info {\n  color: var( --color-base600 );\n  border: none;\n  padding: var( --size-padMedium );\n  font-size: var( --size-fontCaption );\n  text-transform: none;\n  background-color: var( --color-base025 );\n}\n.text.text-comparator {\n  text-align: center;\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillError.text-tagError {\n  color: var( --color-danger500 );\n  border: 1px solid var( --color-danger500 );\n  font-size: var( --size-large );\n  font-weight: bold;\n  border-radius: 2px;\n}\n.text.text-caption.text-captionCurrent {\n  color: currentColor;\n}\n.text.text-mobileNavSubtitle {\n  font: 600 16px/26px Inter;\n  color: var( --color-TopNavText );\n  height: 48px;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n.text.text-navSecondaryMobileTitle {\n  font: bold 18px/24px Inter;\n  color: var( --color-SideNavText );\n  height: 48px;\n  padding: 8px 16px;\n}\n.text.text-navSecondaryMobileHeader {\n  font: 600 13px/20px Inter;\n  color: var( --color-SideNavHeader );\n  width: 100%;\n  height: 32px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.text.text-mobileScreenTitle {\n  font: bold 16px/24px Inter;\n  color: var( --color-base900 );\n  padding: 4px 8px;\n}\n.text.text-mobileOptNavTitle {\n  font: bold 18px/24px Inter;\n  color: var( --color-base900 );\n}\n.text.text-mobileNavBarHeader {\n  font: 600 13px/20px Inter;\n  color: var( --color-base600 );\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.text.text-ruleTrigger {\n  font: 600 13px/20px Inter;\n  color: #394756;\n}\n.text.text-ruleBlockTitle {\n  font: bolder 15px/24px Inter;\n  color: var( --color-base700 );\n}\n.text.text-ruleBlockDescription {\n  font: normal 15px/24px Inter;\n  color: var( --color-base700 );\n  margin-left: 32px;\n  margin-right: var( --size-padXLarge );\n  padding-bottom: var( --size-padSmall );\n}\n.text.text-caption.text-captionLeft {\n  text-align: left;\n}\n.text.text-linkTable {\n  color: var( --color-brand500 );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillStatus {\n  background-color: var( --color-brand050 );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillGood {\n  background-color: var( --color-success050 );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillAlert {\n  background-color: var( --color-danger050 );\n}\n.text.text-columnLabel.text-columnValue.text-value {\n  color: var( --color-base800 );\n  padding: 2px var( --size-padMedium );\n  font-weight: normal;\n  border-radius: 12px;\n  background-color: transparent;\n}\n.text.text-columnLabel.text-columnValue.text-value.text-valueLowBattery {\n  font-weight: 600;\n}\n.text.text-subtitle.text-dashboardCardTitle.text-dashboardGridCardTitle {\n  padding-bottom: var( --size-medium );\n}\n.text.text-caption.text-passwordRequirement.text-passwordRequirementError {\n  color: var( --color-danger700 );\n}\n.text.text-releaseAvailable {\n  color: var( --color-base700 );\n  font-size: var( --size-fontBody );\n}\n.text.text-openingHoursHeader {\n  font-weight: 500;\n}\n.text.text-operatingHoursDay {\n  font-weight: 500;\n}\n.text.text-groupingsCount {\n  font: var( --size-fontCaptionSmall ) var( --fontFamily-body );\n  color: var( --color-white );\n  padding: var( --size-padSmall ) 8px;\n  border-radius: 10000px;\n  background-color: var( --color-brand500 );\n}\n.text.text-groupingsCount.text-groupingsCountEmpty {\n  color: var( --color-base400 );\n  background-color: var( --color-base050 );\n}\n.text.text-title.text-formTitle.text-formTitleCenter {\n  text-align: center;\n}\n.text.text-columnLabel.text-columnValue.text-value.text-valueGoodBattery {\n  font-weight: 600;\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-arrayValue {\n  font: normal 14px/20px Inter;\n  color: var( --color-base800 );\n  border: 1px solid transparent;\n  margin: 0px;\n  padding: 2px var( --size-padMedium );\n}\n.text.text-ruleTargetName {\n  color: #8a004f;\n}\n.text.text-rulePathSeparator {\n  color: var( --color-base400 );\n}\n.text.text-attributeTableUnitSuffix {\n  color: var( --color-base500 );\n  padding-right: 8px;\n}\n.text.text-columnLabel.text-columnValue.text-selectorColumnValue {\n  border: 1px solid transparent;\n  padding: var( --size-small ) var( --size-medium );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-tablePill {\n  margin: var( --size-padSmall ) var( --size-padMedium );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillWarning.text-tablePillWarning {\n  margin: var( --size-padSmall ) var( --size-padMedium );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillSuccess.text-tablePillSuccess {\n  margin: var( --size-padSmall ) var( --size-padMedium );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillPrimary.text-tablePillPrimary {\n  margin: var( --size-padSmall ) var( --size-padMedium );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillError.text-tablePillError {\n  margin: var( --size-padSmall ) var( --size-padMedium );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillStatus.text-tablePillStatus {\n  margin: var( --size-padSmall ) var( --size-padMedium );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillGood.text-tablePillGood {\n  margin: var( --size-padSmall ) var( --size-padMedium );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillAlert.text-tablePillAlert {\n  margin: var( --size-padSmall ) var( --size-padMedium );\n}\n.text.text-deviceSelectorResults {\n  margin-top: var( --size-padLarge );\n}\n.text.text-tempUserShareError {\n  color: var( --color-danger700 );\n  width: auto;\n  border: 1px solid var( --color-danger700 );\n  padding: 8px;\n  font-size: var( --size-fontBodySmall );\n  font-weight: 600;\n  border-radius: var( --size-padSmall );\n  background-color: var( --color-danger050 );\n}\n.text.text-aggregationLabel.text-aggregationEnumAggLabel {\n  text-transform: capitalize;\n}\n.text.text-caption.text-inputCaption {\n  color: var( --color-base500 );\n  padding-top: 6px;\n}\n.text.text-attributeDetailUnitSuffix {\n  color: var( --color-base700 );\n  font-weight: 600;\n}\n.text.text-attributePercentEditor {\n  min-width: 35px;\n  text-align: center;\n}\n.text.text-bodySmall.text-detailValue.text-detailValueNoPad {\n  padding: 0px;\n}\n.text.text-title.text-tvCollectionItemTitle {\n  color: var( --color-base800 );\n  text-align: left;\n}\n.text.text-bodySmall.text-detailLabel.text-tvDetailLabelNoPad {\n  color: var( --color-base800 );\n  padding: 0px;\n}\n.text.text-bodySmall.text-detailValue.text-detailValueNoPad.text-tvDetailValueNoPad {\n  color: var( --color-base800 );\n}\n.text.text-title.text-deviceCode {\n  font: 600 var( --size-padXXLarge ) Inter;\n}\n.text.text-iconSuccessLarge {\n  color: var( --color-success700 );\n  font-size: 90px;\n}\n.text.text-title.text-titleLarge {\n  font-size: 50px;\n}\n.text.text-body.text-bodyLarge {\n  font-size: 20px;\n}\n.text.text-captionSmall.text-altLoginMethod {\n  height: 40px;\n  max-width: 90px;\n}\n.text.text-captionSmall.text-altLoginMethod.text-altLoginMethodSmall {\n  height: auto;\n  font-size: var( --size-fontBodySmall );\n}\n.text.text-bodySmall.text-bodySmallBold {\n  font-weight: bold;\n}\n.text.text-body.text-formBody.text-formBodyCenter.text-qrCodeInstruction {\n  text-align: center;\n}\n.text.text-bodySmall.text-bodySmallBold.text-bodySmallBoldCenter {\n  text-align: center;\n}\n.text.text-title.text-userCode {\n  text-transform: none;\n}\n.text.text-bodySmall.text-bodySmallCenter {\n  text-align: center;\n}\n.text.text-body.text-formBody.text-formBodyCenter {\n  text-align: center;\n  text-decoration: none;\n}\n.text.text-errorTitle {\n  color: var( --color-danger500 );\n  font-size: var( --size-large );\n  font-weight: 600;\n  line-height: var( --size-padXLarge );\n}\n.text.text-title.text-pageTitle.text-rsrcImageDetailTitle {\n  color: var( --color-white );\n  overflow: hidden;\n  max-width: 50dvw;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.text.text-detailRsrcTitle {\n  overflow: hidden;\n  max-width: 90%;\n  font-weight: bold;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.text.text-perPage {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: clip;\n}\n.text.text-layerToolbar {\n  color: var( --color-white );\n  width: 30px;\n  height: 30px;\n  font-size: var( --size-fontH2 );\n  font-weight: bold;\n}\n.text.text-videoControlsLoader {\n  color: var( --color-white );\n  font-size: 48px;\n  font-weight: bold;\n}\n.text.text-errorTitle.text-videoControlsError {\n  text-align: center;\n}\n.text.text-videoControlsPoster {\n  color: var( --color-white );\n  font-size: var( --size-fontH1 );\n}\n.text.text-captionSmall.text-timelineAxisTick.text-timelineAxisSubTick {\n  color: var( --color-base300 );\n}\n.text.text-videoControlsMessage {\n  color: var( --color-white );\n  font-size: var( --size-fontH2 );\n  text-align: center;\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillStatus.text-videoPlayerPill {\n  color: var( --color-tertiaryBrandD );\n  background-color: #dae1fa;\n}\n.text.text-subtitle.text-detailTitle.text-detailRsrcItemTitle {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.text.text-bodySmall.text-detailValue.text-detailRsrcItemValue {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.text.text-errorTitle.text-videoControlsError.text-rsrcTimelineMessage {\n  color: var( --color-base700 );\n}\n.text.text-loadingSpinnerLarge.text-loadingSpinnerLargeLight {\n  color: var( --color-white );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillSuccess.text-pillClosed {\n  background-color: var( --color-base050 );\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillWarning.text-pillOpen.text-tablePillOpen {\n  color: var( --color-base700 );\n  margin: var( --size-padSmall ) var( --size-padMedium );\n  font-size: var( --size-fontBodySmall );\n  font-weight: 500;\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillSuccess.text-pillClosed.text-tablePillClosed {\n  color: var( --color-base700 );\n  margin: var( --size-padSmall ) var( --size-padMedium );\n  font-size: var( --size-fontBodySmall );\n  font-weight: 500;\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillSuccess.text-pillSourceUser {\n  background-color: #e0f7f7;\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillSuccess.text-pillSourceUser.text-tablePillSourceUser {\n  color: var( --color-base700 );\n  margin: var( --size-padSmall ) var( --size-padMedium );\n  font-size: var( --size-fontBodySmall );\n  font-weight: 500;\n  background-color: #d8e3fc;\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillSuccess.text-pillSourceUser.text-pillSourceAi.text-tablePillSourceAi {\n  color: var( --color-base700 );\n  margin: var( --size-padSmall ) var( --size-padMedium );\n  font-size: var( --size-fontBodySmall );\n  font-weight: 500;\n  background-color: var( --color-success050 );\n}\n.text.text-bodySmall.text-detailValue.text-ogDetailValue {\n  margin-left: auto;\n}\n.text.text-chartRolloverHeader {\n  padding: 8px 12px;\n  font-size: 18px;\n  font-weight: 700;\n  border-bottom: 1px solid var( --color-base200 );\n  background-color: var( --color-base050 );\n}\n.text.text-lineDetailLabel {\n  font-size: var( --size-fontH3 );\n}\n.text.text-linePerformancePill {\n  padding: 2px 8px;\n  font-weight: 600;\n  border-radius: 12px;\n  background-color: var( --color-base100 );\n}\n.text.text-moldHalfDetailValue {\n  font-size: var( --size-fontBody );\n  font-weight: bold;\n}\n.text.text-moldHalfStageDetailValue {\n  font-size: var( --size-fontH2 );\n  font-weight: 600;\n}\n.text.text-captionBold.text-workerCountTitle {\n  font-size: 14px;\n  text-transform: uppercase;\n}\n.text.text-bodySmall.text-detailValue.text-ganttRolloverValue {\n  margin-left: auto;\n}\n.text.text-subtitle.text-editorTitle.text-ganttRolloverHeader {\n  padding: 8px 12px;\n  border-bottom: 1px solid var( --color-base200 );\n  background-color: var( --color-base050 );\n}\n.text.text-paceGood {\n  color: #029e2e;\n  font-size: 50px;\n  font-weight: 700;\n  line-height: 32px;\n}\n.text.text-paceGood.text-paceBad {\n  color: var( --color-danger500 );\n}\n.text.text-columnLabel.text-columnLabelCustom {\n  padding: 0px 6px;\n  font-size: 15px;\n  line-height: 36px;\n}\n.text.text-columnLabel.text-columnLabelCustom.text-columnLabelCustomVertical {\n  width: fit-content;\n  font-size: 16px;\n  line-height: 16px;\n}\n.text.text-columnLabel.text-columnLabelCustom.text-columnLabelCustomVertical.text-columnSubCustomVertical {\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 12px;\n}\n.text.text-columnHeaderCustom {\n  font-size: 16px;\n  font-weight: 600;\n}\n.text.text-paceCardHeader {\n  height: 26px;\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 26px;\n}\n.text.text-paceCardDetailContent {\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 20px;\n}\n.text.text-caption.text-paceCardDetailHeader {\n  overflow: hidden;\n  font-size: 15px;\n  font-weight: 600;\n  white-space: nowrap;\n  text-overflow: clip;\n}\n.text.text-paceGood.text-pace {\n  color: var( --color-base700 );\n  padding: 0px;\n  font-weight: 700;\n}\n.text.text-paceCardHeader.text-overallPaceCardHeader {\n  height: auto;\n  font-size: 20px;\n  text-align: center;\n  line-height: 39px;\n}\n.text.text-paceCardHeader.text-factoryPaceCardHeader {\n  font-size: 14px;\n}\n.text.text-paceGood.text-factoryPaceGood {\n  padding: 0px 0px 0px 4px;\n  font-size: 16px;\n  line-height: 18px;\n}\n.text.text-paceGood.text-paceBad.text-factoryPaceBad {\n  padding: 0px 0px 0px 4px;\n  font-size: 16px;\n  line-height: 18px;\n}\n.text.text-caption.text-paceCardDetailHeader.text-factoryPaceCardDetailHeader {\n  font-size: 14px;\n}\n.text.text-factoryOverallPace {\n  color: var( --color-base700 );\n  font-size: 38px;\n  font-weight: 700;\n  line-height: 46px;\n}\n.text.text-caption.text-paceCardDetailHeader.text-overallPaceCardDetailHeader {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20px;\n}\n.text.text-caption.text-paceCardDetailHeader.text-overallPaceCardDetailHeader.text-overallPaceCardDetailHeaderSmall {\n  font-size: 14px;\n  line-height: 16px;\n}\n.text.text-paceCardDetailContent.text-overallPaceCardDetailContent {\n  font-size: 26px;\n}\n.text.text-paceCardDetailContent.text-factoryPaceCardDetailContent {\n  font-size: 16px;\n  line-height: 16px;\n}\n.text.text-factoryNoCollectionHeader {\n  color: var( --color-danger500 );\n  font-size: 24px;\n  font-weight: 700;\n}\n.text.text-factoryNoCollectionBody {\n  width: 510px;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 30px;\n}\n.text.text-mobilePaceCardHeader {\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 18px;\n}\n.text.text-paceGood.text-factoryPaceGood.text-mobilePaceGood {\n  font-size: 30px;\n  font-weight: 700;\n  padding-left: 4px;\n}\n.text.text-paceGood.text-paceBad.text-factoryPaceBad.text-mobilePaceBad {\n  font-size: 30px;\n  font-weight: 700;\n}\n.text.text-paceGood.text-factoryPaceGood.text-mobilePaceGood.text-mobileSmallPaceGood {\n  font-size: 20px;\n}\n.text.text-paceGood.text-paceBad.text-factoryPaceBad.text-mobilePaceBad.text-mobileSmallPaceBad {\n  font-size: 20px;\n}\n.text.text-factoryNoCollectionHeader.text-mobileNoCollectionHeader {\n  font-size: 12px;\n  line-height: 15px;\n}\n.text.text-factoryNoCollectionBody.text-mobileNoCollectionBody {\n  width: auto;\n  font-size: 10px;\n  line-height: 16px;\n}\n.text.text-columnLabel.text-columnValue.text-pill.text-pillInProgress.text-tablePillInProgress {\n  margin: var( --size-padSmall ) var( --size-padMedium );\n}\n.text.text-plyLayerTitle {\n  color: var( --color-white );\n  font-size: 70cqh;\n  font-weight: bold;\n}\n.text.text-plyLayerLastUpdated {\n  color: var( --color-white );\n  font-size: 45cqh;\n}\n.text.text-plyLayerCurrentTitle {\n  font-size: 16cqh;\n  font-weight: 600;\n}\n.text.text-plyLayerCurrentId {\n  font-size: 42cqw;\n  font-weight: 600;\n}\n.text.text-plyLayerPill {\n  color: var( --color-white );\n  border: 3px solid var( --color-bespokeWarningBorder );\n  font-size: 40cqh;\n  font-weight: 700;\n  border-radius: 6cqh;\n  background-color: var( --color-bespokeWarningBorder );\n}\n.text.text-plyLayerPill.text-plyLayerPillSuccess {\n  color: var( --color-white );\n  font-size: 1em;\n  font-weight: 600;\n  background-color: var( --color-bespokeSuccessBorder );\n  border-top-color: var( --color-bespokeSuccessBorder );\n  border-left-color: var( --color-bespokeSuccessBorder );\n  border-right-color: var( --color-bespokeSuccessBorder );\n  border-bottom-color: var( --color-bespokeSuccessBorder );\n}\n.text.text-plyLayerPill.text-plyLayerPillSuccess.text-plyLayerPillSuccessLarge {\n  font-size: 14cqh;\n  border-radius: 32px;\n  border-top-width: 2cqh;\n  border-left-width: 2cqh;\n  border-right-width: 2cqh;\n  border-bottom-width: 2cqh;\n}\n.text.text-plyLayerPill.text-plyLayerPillError {\n  background-color: var( --color-pillErrorBorder );\n  border-top-color: var( --color-bespokeErrorBorder );\n  border-left-color: var( --color-bespokeErrorBorder );\n  border-right-color: var( --color-bespokeErrorBorder );\n  border-bottom-color: var( --color-bespokeErrorBorder );\n}\n.text.text-plyLayerPill.text-plyLayerPillError.text-plyLayerPillErrorLarge {\n  font-size: 14cqh;\n  border-radius: 32px;\n  border-top-width: 2cqh;\n  border-left-width: 2cqh;\n  border-right-width: 2cqh;\n  border-bottom-width: 2cqh;\n}\n.text.text-plyLayerPreviousHeader {\n  font-size: 7cqh;\n  font-weight: 600;\n}\n.text.text-plyLayerPill.text-plyLayerPillLarge {\n  font-size: 14cqh;\n  border-radius: 32px;\n  border-top-width: 2cqh;\n  border-left-width: 2cqh;\n  border-right-width: 2cqh;\n  border-bottom-width: 2cqh;\n}\n.text.text-plyLayerPill.text-plyLayerPillInProgress {\n  background-color: var( --color-base300 );\n  border-top-color: var( --color-base300 );\n  border-left-color: var( --color-base300 );\n  border-right-color: var( --color-base300 );\n  border-bottom-color: var( --color-base300 );\n}\n.text.text-plyLayerPill.text-plyLayerPillInProgress.text-plyLayerPillInProgressLarge {\n  font-size: 14cqh;\n  border-radius: 32px;\n  border-top-width: 2cqh;\n  border-left-width: 2cqh;\n  border-right-width: 2cqh;\n  border-bottom-width: 2cqh;\n}\n.text.text-plyLayerCurrentId.text-plyLayerPreviousId {\n  overflow: hidden;\n  font-size: 8cqw;\n  font-weight: bold;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.text.text-plyLayerNoDataTitle {\n  color: var( --color-white );\n  font-size: 8vh;\n}\n.text.text-plyLayerNoDataSubtitle {\n  color: var( --color-white );\n  font-size: 4vh;\n}\n.text.text-delayDescriptionTitle {\n  font-size: 20px;\n  font-weight: 700;\n}\n.text.text-delayDescriptionSub {\n  font-size: 14px;\n  font-weight: 400;\n}\n.text.text-mobileSmallPaceIdle {\n  font-size: 20px;\n  font-weight: 700;\n}\n.text.text-plyLayerTitle.text-plyLayersSubtitle {\n  font-size: 3.5cqh;\n}\n.text.text-plyLayerTitle.text-plyLayersSubtitle.text-plyLayerStatsSubtitle {\n  font-size: 60cqh;\n}\n.text.text-pdfHeaderTitle {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 18px;\n}\n.text.text-pdfHeaderSub {\n  font-size: 14px;\n  font-weight: 400;\n}\n.text.text-pdfTableHeader {\n  padding: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n.text.text-columnLabel.text-columnValue.text-columnValueFixedWidth {\n  max-width: 400px;\n}\n.text.text-plyLayerPill.text-plyLayerPillUnverifiedTimeout {\n  background-color: #194edc;\n  border-top-style: solid;\n  border-top-color: #194edc;\n  border-left-style: solid;\n  border-left-color: #194edc;\n  border-right-style: solid;\n  border-right-color: #194edc;\n  border-bottom-style: solid;\n  border-bottom-color: #194edc;\n}\n.text.text-plyLayerShopFloorPill {\n  color: var( --color-white );\n  border: 3px solid var( --color-bespokeWarningBorder );\n  font-weight: bold;\n  border-radius: 6px;\n  background-color: var( --color-bespokeWarningBorder );\n}\n.text.text-plyLayerShopFloorPill.text-plyLayerShopFloorPillSuccess {\n  background-color: var( --color-bespokeSuccessBorder );\n  border-top-color: var( --color-bespokeSuccessBorder );\n  border-left-color: var( --color-bespokeSuccessBorder );\n  border-right-color: var( --color-bespokeSuccessBorder );\n  border-bottom-color: var( --color-bespokeSuccessBorder );\n}\n.text.text-plyLayerShopFloorPill.text-plyLayerShopFloorPillError {\n  background-color: var( --color-pillErrorBorder );\n  border-top-color: var( --color-pillErrorBorder );\n  border-left-color: var( --color-pillErrorBorder );\n  border-right-color: var( --color-pillErrorBorder );\n  border-bottom-color: var( --color-pillErrorBorder );\n}\n.text.text-plyLayerShopFloorPill.text-plyLayerShopFloorPillUnverifiedTimeout {\n  background-color: #194edc;\n  border-top-color: #194edc;\n  border-left-color: #194edc;\n  border-right-color: #194edc;\n  border-bottom-color: #194edc;\n}\n.text.text-plyLayerShopFloorPill.text-plyLayerShopFloorPillInProgress {\n  background-color: var( --color-base300 );\n  border-top-color: var( --color-base300 );\n  border-left-color: var( --color-base300 );\n  border-right-color: var( --color-base300 );\n  border-bottom-color: var( --color-base300 );\n}\n.text.text-subtitle.text-loadTimeoutError {\n  color: var( --color-white );\n  text-align: center;\n}\n.text-tagGood {\n  color: #097b22;\n  border: 1px solid #097b22;\n  height: 26px;\n  padding: 0px 8px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  border-radius: 4px;\n  background-color: #e6fcef;\n}\n.text-tagGood.text-tagBad {\n  color: #db253d;\n  background-color: #fde2e2;\n  border-top-color: #db253d;\n  border-left-color: #db253d;\n  border-right-color: #db253d;\n  border-bottom-color: #db253d;\n}\n.text-tagGood.text-tagNeutral {\n  color: #394756;\n  background-color: #f3f5f6;\n  border-top-color: #acb7c3;\n  border-left-color: #acb7c3;\n  border-right-color: #acb7c3;\n  border-bottom-color: #acb7c3;\n}\n.text-tagGood.text-mobileTagGood {\n  font-size: 14px;\n}\n.text-tagGood.text-tagBad.text-mobileTagBad {\n  font-size: 14px;\n}\n.text-tagGood.text-tagNeutral.text-mobileTagNeutral {\n  font-size: 14px;\n}\n.text-mobilePaceCardBigHeader {\n  font-size: 20px;\n  font-weight: 700;\n}\n.text-paceIdle {\n  font-size: 50px;\n  font-weight: 700;\n  line-height: 1em;\n}\n.text-factoryPaceIdle {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `text_lTMWQ`,
	"text-title": `text-title_WfPPM`,
	"text-subtitle": `text-subtitle_t9FZZ`,
	"text-body": `text-body_imp3J`,
	"text-bodySmall": `text-bodySmall_VKpbM`,
	"text-caption": `text-caption_G4Unj`,
	"text-captionSmall": `text-captionSmall_Hur6o`,
	"text-navLogoLabel": `text-navLogoLabel_Qd6GS`,
	"text-pageTitle": `text-pageTitle_mL8wF`,
	"text-sectionTitle": `text-sectionTitle_esp1b`,
	"text-formTitle": `text-formTitle_9UDmF`,
	"text-listItemTitle": `text-listItemTitle_hIUTK`,
	"text-inputCaptionSmall": `text-inputCaptionSmall_MfzSa`,
	"text-inputCaptionSmallError": `text-inputCaptionSmallError_tmzqO`,
	"text-loginWarning": `text-loginWarning_jPgNt`,
	"text-mobileMapTitle": `text-mobileMapTitle_bfnfj`,
	"text-mobileTitle": `text-mobileTitle_uypJS`,
	"text-captionBold": `text-captionBold_h1clF`,
	"text-captionSmallBold": `text-captionSmallBold_L3Rrx`,
	"text-detailLabel": `text-detailLabel_lugu0`,
	"text-detailValue": `text-detailValue_vMTOy`,
	"text-detailSuffix": `text-detailSuffix_H3pak`,
	"text-screenTitle": `text-screenTitle_nvkbp`,
	"text-sideNav": `text-sideNav_ginSW`,
	"text-loginLogo": `text-loginLogo_G5CgU`,
	"text-mobileUserNavBar": `text-mobileUserNavBar_UoTrQ`,
	"text-groupTitle": `text-groupTitle_uWwWe`,
	"text-dashboardCardTitle": `text-dashboardCardTitle_ejgA8`,
	"text-dialogTitle": `text-dialogTitle_aufao`,
	"text-rootEditorTitle": `text-rootEditorTitle_GUPMo`,
	"text-actionBar": `text-actionBar_Rlz6t`,
	"text-sideNavBarHeader": `text-sideNavBarHeader_cWVvI`,
	"text-networkOffline": `text-networkOffline_8Jspf`,
	"text-sideNavSmall": `text-sideNavSmall_SB676`,
	"text-linearViewHeaderCell1": `text-linearViewHeaderCell1_GCINt`,
	"text-linearViewHeaderCell2": `text-linearViewHeaderCell2_U7HiU`,
	"text-pairingErrorSubtitle": `text-pairingErrorSubtitle_tQCYt`,
	"text-bodyCentered": `text-bodyCentered_y32BH`,
	"text-resendSuccess": `text-resendSuccess_fo8dm`,
	"text-twoFactorWarning": `text-twoFactorWarning_lryJq`,
	"text-columnLabel": `text-columnLabel_kSGax`,
	"text-columnValue": `text-columnValue_KQIIR`,
	"text-pill": `text-pill_qbxb6`,
	"text-pillPrimary": `text-pillPrimary_WlIVu`,
	"text-pillSuccess": `text-pillSuccess_zpDC7`,
	"text-pillWarning": `text-pillWarning_r7Ifb`,
	"text-pillError": `text-pillError_dE85C`,
	"text-resendCodeSuccess": `text-resendCodeSuccess_SbNfE`,
	"text-twoStepTitle": `text-twoStepTitle_wGuTW`,
	"text-hint": `text-hint_T10nR`,
	"text-missingRelTitle": `text-missingRelTitle_GidYd`,
	"text-expressionParen": `text-expressionParen_mVKlJ`,
	"text-operatingHoursTitle": `text-operatingHoursTitle_GeIqF`,
	"text-hintSmall": `text-hintSmall_wlOan`,
	"text-aggregationTitle": `text-aggregationTitle_be0xh`,
	"text-aggregationLabel": `text-aggregationLabel_mBnDK`,
	"text-aggregationValue": `text-aggregationValue_KsauC`,
	"text-conditionAttributeLabel": `text-conditionAttributeLabel_VawrG`,
	"text-info": `text-info_F1rg4`,
	"text-comparator": `text-comparator_HszGC`,
	"text-tagError": `text-tagError_trBFv`,
	"text-captionCurrent": `text-captionCurrent_A5P9B`,
	"text-mobileNavSubtitle": `text-mobileNavSubtitle_A5MAI`,
	"text-navSecondaryMobileTitle": `text-navSecondaryMobileTitle_ZVW2f`,
	"text-navSecondaryMobileHeader": `text-navSecondaryMobileHeader_g8eWp`,
	"text-mobileScreenTitle": `text-mobileScreenTitle_CCYjB`,
	"text-mobileOptNavTitle": `text-mobileOptNavTitle_Og862`,
	"text-mobileNavBarHeader": `text-mobileNavBarHeader_JTqdF`,
	"text-ruleTrigger": `text-ruleTrigger_Vq8NC`,
	"text-ruleBlockTitle": `text-ruleBlockTitle_CjUly`,
	"text-ruleBlockDescription": `text-ruleBlockDescription_FlK1e`,
	"text-captionLeft": `text-captionLeft_xOGX5`,
	"text-linkTable": `text-linkTable_Hyd8b`,
	"text-pillStatus": `text-pillStatus_xKjH1`,
	"text-pillGood": `text-pillGood_W23cd`,
	"text-pillAlert": `text-pillAlert_xidrh`,
	"text-value": `text-value_iVc37`,
	"text-valueLowBattery": `text-valueLowBattery_IcXJv`,
	"text-dashboardGridCardTitle": `text-dashboardGridCardTitle_KM5qN`,
	"text-passwordRequirement": `text-passwordRequirement_Ydd82`,
	"text-passwordRequirementError": `text-passwordRequirementError_WHJdk`,
	"text-releaseAvailable": `text-releaseAvailable_is_s7`,
	"text-openingHoursHeader": `text-openingHoursHeader_gZsJR`,
	"text-operatingHoursDay": `text-operatingHoursDay_GKOXX`,
	"text-groupingsCount": `text-groupingsCount_oyrAM`,
	"text-groupingsCountEmpty": `text-groupingsCountEmpty_Y6pRv`,
	"text-formTitleCenter": `text-formTitleCenter_AWy0q`,
	"text-valueGoodBattery": `text-valueGoodBattery_aDKqv`,
	"text-arrayValue": `text-arrayValue_TYuQk`,
	"text-ruleTargetName": `text-ruleTargetName_n2FXn`,
	"text-rulePathSeparator": `text-rulePathSeparator_lQihx`,
	"text-attributeTableUnitSuffix": `text-attributeTableUnitSuffix_RKicd`,
	"text-selectorColumnValue": `text-selectorColumnValue_e66ec`,
	"text-tablePill": `text-tablePill_V1b4m`,
	"text-tablePillWarning": `text-tablePillWarning_JIuro`,
	"text-tablePillSuccess": `text-tablePillSuccess_AtbUa`,
	"text-tablePillPrimary": `text-tablePillPrimary_iAps7`,
	"text-tablePillError": `text-tablePillError_j7a2T`,
	"text-tablePillStatus": `text-tablePillStatus_qdYQo`,
	"text-tablePillGood": `text-tablePillGood_LexDk`,
	"text-tablePillAlert": `text-tablePillAlert_lMRSB`,
	"text-deviceSelectorResults": `text-deviceSelectorResults_B1FMI`,
	"text-tempUserShareError": `text-tempUserShareError_fnb0z`,
	"text-aggregationEnumAggLabel": `text-aggregationEnumAggLabel_KjzQ3`,
	"text-inputCaption": `text-inputCaption_Xhej2`,
	"text-attributeDetailUnitSuffix": `text-attributeDetailUnitSuffix_hu4IC`,
	"text-attributePercentEditor": `text-attributePercentEditor_Q3FWq`,
	"text-detailValueNoPad": `text-detailValueNoPad_BuTAs`,
	"text-tvCollectionItemTitle": `text-tvCollectionItemTitle_aGmSG`,
	"text-tvDetailLabelNoPad": `text-tvDetailLabelNoPad_gGNvp`,
	"text-tvDetailValueNoPad": `text-tvDetailValueNoPad_QYW5n`,
	"text-deviceCode": `text-deviceCode_e54cN`,
	"text-iconSuccessLarge": `text-iconSuccessLarge_hzpKM`,
	"text-titleLarge": `text-titleLarge_gKZ1G`,
	"text-bodyLarge": `text-bodyLarge_aB4ed`,
	"text-altLoginMethod": `text-altLoginMethod_W7XQX`,
	"text-altLoginMethodSmall": `text-altLoginMethodSmall_RfXYY`,
	"text-bodySmallBold": `text-bodySmallBold_XlW6h`,
	"text-formBody": `text-formBody_vQoVb`,
	"text-formBodyCenter": `text-formBodyCenter___dyo`,
	"text-qrCodeInstruction": `text-qrCodeInstruction__GZxg`,
	"text-bodySmallBoldCenter": `text-bodySmallBoldCenter_KLVgU`,
	"text-userCode": `text-userCode_z2SBv`,
	"text-bodySmallCenter": `text-bodySmallCenter_E5Czf`,
	"text-errorTitle": `text-errorTitle_nPw25`,
	"text-rsrcImageDetailTitle": `text-rsrcImageDetailTitle_FD36I`,
	"text-detailRsrcTitle": `text-detailRsrcTitle_NcBVc`,
	"text-perPage": `text-perPage_t4EWD`,
	"text-layerToolbar": `text-layerToolbar_shTQ0`,
	"text-videoControlsLoader": `text-videoControlsLoader_KOwTo`,
	"text-videoControlsError": `text-videoControlsError_BzGT4`,
	"text-videoControlsPoster": `text-videoControlsPoster_yQ1XP`,
	"text-timelineAxisTick": `text-timelineAxisTick_eWRhv`,
	"text-timelineAxisSubTick": `text-timelineAxisSubTick_djGrt`,
	"text-videoControlsMessage": `text-videoControlsMessage_JwquU`,
	"text-videoPlayerPill": `text-videoPlayerPill_XISjX`,
	"text-detailTitle": `text-detailTitle_TihjK`,
	"text-detailRsrcItemTitle": `text-detailRsrcItemTitle_uui09`,
	"text-detailRsrcItemValue": `text-detailRsrcItemValue_zffQv`,
	"text-rsrcTimelineMessage": `text-rsrcTimelineMessage_ujc5T`,
	"text-loadingSpinnerLarge": `text-loadingSpinnerLarge_Gmyyg`,
	"text-loadingSpinnerLargeLight": `text-loadingSpinnerLargeLight_QZgPe`,
	"text-pillClosed": `text-pillClosed_vMGFz`,
	"text-pillOpen": `text-pillOpen_jD8Rm`,
	"text-tablePillOpen": `text-tablePillOpen_OLmro`,
	"text-tablePillClosed": `text-tablePillClosed_FyVdU`,
	"text-pillSourceUser": `text-pillSourceUser_GTwwJ`,
	"text-tablePillSourceUser": `text-tablePillSourceUser_l8eJ1`,
	"text-pillSourceAi": `text-pillSourceAi_YLYHH`,
	"text-tablePillSourceAi": `text-tablePillSourceAi_cGaMD`,
	"text-ogDetailValue": `text-ogDetailValue_QHWNI`,
	"text-chartRolloverHeader": `text-chartRolloverHeader_GPVIK`,
	"text-lineDetailLabel": `text-lineDetailLabel_v7olj`,
	"text-linePerformancePill": `text-linePerformancePill_pitWB`,
	"text-moldHalfDetailValue": `text-moldHalfDetailValue_WhGce`,
	"text-moldHalfStageDetailValue": `text-moldHalfStageDetailValue_CVzmM`,
	"text-workerCountTitle": `text-workerCountTitle_PIip6`,
	"text-ganttRolloverValue": `text-ganttRolloverValue_AG0xR`,
	"text-editorTitle": `text-editorTitle_Qp6Lf`,
	"text-ganttRolloverHeader": `text-ganttRolloverHeader_AqQ3u`,
	"text-paceGood": `text-paceGood_GM9Qj`,
	"text-paceBad": `text-paceBad_X6xs9`,
	"text-columnLabelCustom": `text-columnLabelCustom_tpNtJ`,
	"text-columnLabelCustomVertical": `text-columnLabelCustomVertical_L6wZQ`,
	"text-columnSubCustomVertical": `text-columnSubCustomVertical_B8HFC`,
	"text-columnHeaderCustom": `text-columnHeaderCustom_pQdhw`,
	"text-paceCardHeader": `text-paceCardHeader_NXwa9`,
	"text-paceCardDetailContent": `text-paceCardDetailContent_hUfT7`,
	"text-paceCardDetailHeader": `text-paceCardDetailHeader_trzS2`,
	"text-pace": `text-pace__NiLC`,
	"text-overallPaceCardHeader": `text-overallPaceCardHeader_FAW7V`,
	"text-factoryPaceCardHeader": `text-factoryPaceCardHeader_jKteF`,
	"text-factoryPaceGood": `text-factoryPaceGood_KQSZQ`,
	"text-factoryPaceBad": `text-factoryPaceBad_cPQTj`,
	"text-factoryPaceCardDetailHeader": `text-factoryPaceCardDetailHeader_N9Ykj`,
	"text-factoryOverallPace": `text-factoryOverallPace_sxdWZ`,
	"text-overallPaceCardDetailHeader": `text-overallPaceCardDetailHeader_XkAcH`,
	"text-overallPaceCardDetailHeaderSmall": `text-overallPaceCardDetailHeaderSmall_Kabh_`,
	"text-overallPaceCardDetailContent": `text-overallPaceCardDetailContent_vO4FN`,
	"text-factoryPaceCardDetailContent": `text-factoryPaceCardDetailContent_kGVAY`,
	"text-factoryNoCollectionHeader": `text-factoryNoCollectionHeader_Wb4jQ`,
	"text-factoryNoCollectionBody": `text-factoryNoCollectionBody_PXZc_`,
	"text-mobilePaceCardHeader": `text-mobilePaceCardHeader_g4PVM`,
	"text-mobilePaceGood": `text-mobilePaceGood_XBa0g`,
	"text-mobilePaceBad": `text-mobilePaceBad_f566Z`,
	"text-mobileSmallPaceGood": `text-mobileSmallPaceGood_dL3Am`,
	"text-mobileSmallPaceBad": `text-mobileSmallPaceBad_ks6Jd`,
	"text-mobileNoCollectionHeader": `text-mobileNoCollectionHeader_SkD2e`,
	"text-mobileNoCollectionBody": `text-mobileNoCollectionBody_ZoiQN`,
	"text-pillInProgress": `text-pillInProgress_SHz08`,
	"text-tablePillInProgress": `text-tablePillInProgress_JpI05`,
	"text-plyLayerTitle": `text-plyLayerTitle_h2rD1`,
	"text-plyLayerLastUpdated": `text-plyLayerLastUpdated_oKH5x`,
	"text-plyLayerCurrentTitle": `text-plyLayerCurrentTitle_qp3Mi`,
	"text-plyLayerCurrentId": `text-plyLayerCurrentId_HgPGb`,
	"text-plyLayerPill": `text-plyLayerPill_sOKkq`,
	"text-plyLayerPillSuccess": `text-plyLayerPillSuccess_Ir1de`,
	"text-plyLayerPillSuccessLarge": `text-plyLayerPillSuccessLarge_Ie38t`,
	"text-plyLayerPillError": `text-plyLayerPillError_jSE89`,
	"text-plyLayerPillErrorLarge": `text-plyLayerPillErrorLarge_zBejt`,
	"text-plyLayerPreviousHeader": `text-plyLayerPreviousHeader_u8lSx`,
	"text-plyLayerPillLarge": `text-plyLayerPillLarge_xozOi`,
	"text-plyLayerPillInProgress": `text-plyLayerPillInProgress_NCRSI`,
	"text-plyLayerPillInProgressLarge": `text-plyLayerPillInProgressLarge_ApEQa`,
	"text-plyLayerPreviousId": `text-plyLayerPreviousId_S2qx8`,
	"text-plyLayerNoDataTitle": `text-plyLayerNoDataTitle_r6fTt`,
	"text-plyLayerNoDataSubtitle": `text-plyLayerNoDataSubtitle_xKjAg`,
	"text-delayDescriptionTitle": `text-delayDescriptionTitle_nEyMA`,
	"text-delayDescriptionSub": `text-delayDescriptionSub_IeUb3`,
	"text-mobileSmallPaceIdle": `text-mobileSmallPaceIdle_mw_5x`,
	"text-plyLayersSubtitle": `text-plyLayersSubtitle_qHXn0`,
	"text-plyLayerStatsSubtitle": `text-plyLayerStatsSubtitle_CE_8g`,
	"text-pdfHeaderTitle": `text-pdfHeaderTitle_aHC8W`,
	"text-pdfHeaderSub": `text-pdfHeaderSub_thFEh`,
	"text-pdfTableHeader": `text-pdfTableHeader__2_4R`,
	"text-columnValueFixedWidth": `text-columnValueFixedWidth_ixWRT`,
	"text-plyLayerPillUnverifiedTimeout": `text-plyLayerPillUnverifiedTimeout_n99ik`,
	"text-plyLayerShopFloorPill": `text-plyLayerShopFloorPill_cyNsn`,
	"text-plyLayerShopFloorPillSuccess": `text-plyLayerShopFloorPillSuccess_Gj2JD`,
	"text-plyLayerShopFloorPillError": `text-plyLayerShopFloorPillError_tZU2m`,
	"text-plyLayerShopFloorPillUnverifiedTimeout": `text-plyLayerShopFloorPillUnverifiedTimeout_baep9`,
	"text-plyLayerShopFloorPillInProgress": `text-plyLayerShopFloorPillInProgress_V1ZRa`,
	"text-loadTimeoutError": `text-loadTimeoutError_rf9SV`,
	"text-tagGood": `text-tagGood_pmw3K`,
	"text-tagBad": `text-tagBad_nFRdF`,
	"text-tagNeutral": `text-tagNeutral_lwBgw`,
	"text-mobileTagGood": `text-mobileTagGood_KZoTc`,
	"text-mobileTagBad": `text-mobileTagBad_aaMH1`,
	"text-mobileTagNeutral": `text-mobileTagNeutral_nMJc_`,
	"text-mobilePaceCardBigHeader": `text-mobilePaceCardBigHeader_CFJHk`,
	"text-paceIdle": `text-paceIdle_cXm5B`,
	"text-factoryPaceIdle": `text-factoryPaceIdle_dztb3`
};
export default ___CSS_LOADER_EXPORT___;
